const BackButtonTapped = (employerName: string) => ({
  object_name: 'directDepositOnlineBack',
  screen: 'directDepositOnline',
  screen_name: 'directDepositOnline',
  destination: 'directDepositSearch',
  employer_name: employerName,
})

const EditButtonTapped = (employerName: string) => ({
  object_name: 'directDepositOnlineBack',
  screen: 'directDepositOnline',
  screen_name: 'directDepositOnline',
  destination: 'directDepositSearch',
  cta_title: 'Edit',
  employer_name: employerName,
})

export { BackButtonTapped, EditButtonTapped }
